import { equal } from "assert";
import $ from "jquery";
import slick from "slick-carousel";

document.addEventListener('DOMContentLoaded', function() {

    const testimonialCarousel = $( '.js-testimonial-carousel' );

    if ( testimonialCarousel ) {

        testimonialCarousel.each( function() {
            const carousel = $( this );
            const carouselOptions = {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: true,
                prevArrow: '.js-testimonial-carousel-prev',
                nextArrow: '.js-testimonial-carousel-next',
                dots: true,
                appendDots: '.js-testimonial-carousel-dots',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
                
            }

            carousel.slick( carouselOptions );
        });

    }

    const eventCarousel = $( '.js-event-carousel' );

    if ( eventCarousel ) {

        function setEqualHeight(){
            var maxHeight = 0;
            
            $('.slick-slide').css('height', 'auto');

            $('.slick-slide').each(function(){
                var thisHeight = $(this).outerHeight();
                if (thisHeight > maxHeight) {
                    maxHeight = thisHeight;
                }
            });

            $('.slick-slide').css('height', maxHeight + 'px');
        }

        setEqualHeight();

        // Adjust height on window resize
        $(window).resize(function(){
            setEqualHeight();
        });

        eventCarousel.each( function() {
            const carousel = $( this );
            const carouselOptions = {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                adaptiveHeight: true,
                arrows: true,
                prevArrow: '.js-event-carousel-prev',
                nextArrow: '.js-event-carousel-next',
                dots: true,
                appendDots: '.js-event-carousel-dots',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
                
            }

            carousel.slick( carouselOptions );
        });

    }

});